<template>
  <div class="selectorignored" v-bind:class="{'notedited': !material['edit'], 'collapsible-body ': material['id']}">
  	<div class="row" style="width: 100%;">
    <div class="col s3">
      <template v-if="material.image != null && material.image != undefined">
        <v-lazy-image v-bind:src="material.image" src-placeholder="/nofoto.png" width="200" />
      </template>
      <input type="file" id="input" @change="setImageFile(material, $event.target.name, $event.target.files)" v-if="material.edit">
     </div>
    <div class="col s6 input-field ">
      <div class="row">
      <div class="col s3 right-align">{{$t('materials.name')}}</div> <div class="col s8"><input type="text" name="name" v-model="material.name" :placeholder="$t('materials.name')"  :disabled="material.edit == false"/></div>
    </div>
    <div class="row">
      <div class="col s3 right-align">{{$t('materials.description')}}</div><div class="col s8"><editable v-model="material.description" :placeholder="$t('materials.description')"  class="materialize-textarea" :disabled="material.edit == false"></editable></div>
    </div>
    <div class="row">
      <div class="col s5 right-align">{{$t('materials.measure_unit')}}</div><div class="col s2"><select v-model="material.default_unit" :disabled="material.edit == false">
        <option value="pieces">{{$t('materials.units.pieces')}}</option>
        <option value="grams">{{$t('materials.units.grams')}}</option>
        <option value="metersquare">{{$t('materials.units.metersquare')}}</option>
        <option value="meters">{{$t('materials.units.meters')}}</option>
      </select>
    </div>
  </div>
    </div>
    <div class="col offset-s2 s1">
          <a class="waves-effect waves-light btn-small red" v-on:click="removeMaterial(material)" v-if="hasRemoveListener && material.editable">{{$t('menu.buttons.delete')}}</a>
    </div>
   </div>
  <div class="row" style="margin-top: 16px;" v-if="material.editable">
    <div class="col offset-l10 s4 l2" style="text-align: right;"><a class="waves-effect waves-light btn-large emptygreen" v-on:click="editPest(material)" v-if="material.edit == false">{{$t('menu.buttons.edit')}}</a></div>
    <div class="col  offset-l8 s4 l2" style="text-align: right;"><a class="waves-effect waves-light btn-large cancelbutton" v-on:click="unEditPest(material)" v-if="material.edit"> {{$t('menu.buttons.cancel_changes')}}</a></div>
    <div class="col l2 s4" style="text-align: right; "><a style="width: 100%;" class="waves-effect waves-light btn-large emptygreen" v-on:click="savePest(material)" v-if="material.edit">
            <div v-if="saving" class="preloader-wrapper small active">
                <div class="spinner-layer spinner-red-only">
                    <div class="circle-clipper left">
                        <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                        <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
            {{saving == false ? $t('menu.buttons.save_changes') : ""}}
        </a></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data: function () {
    return {
      order: 1,
      orderby: 'number',
      customers: [],
      saving: false,
      old_material: {}
    }
  },
  props: { material: Object, extended_privileges: Boolean },
  created() {
    if(_.isUndefined(this.material.media)){
      this.material.media = []
      this.material.media.push({"image": ""});
    }
  },
  methods: {
    
    collapse : function(customer){
      customer.collapsed = !(customer.collapsed);
      this.$forceUpdate();
    },
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 1){
          this.order = 0
        }else if(this.order == 0){
          this.order = 1
        }
        
      }else{
        this.orderby = order;
      }
    },
    editPest: function(material){
      material.edit = true;
      this.old_material = _.cloneDeep(material)
      this.$forceUpdate();
    },
    setImageFile: function(doc, name,file){
      doc.media[0].image = file[0];
    },
    unEditPest: function(material){
      if(material.id != undefined){ 
        Object.assign(material, this.old_material)
        this.$emit('cancelMaterial', material);
        material.edit = false;
        this.$forceUpdate();
      }else{
        this.removeMaterial(material);
      }
    },
    removeMaterial: function(material){
        this.$emit('removeMaterial', material);
    },
    savePest: function(material){
      const formData = new FormData();
      for (var key of Object.keys(material)) {
        formData.append('material_item['+key+']', material[key]);
      }
      var i=0;
      for (var reco of material.media) {
        if (material.media[0].image != "") {
          for (var key of Object.keys(reco)) {
            formData.append('material_item[media_attributes]['+i+']['+key+']', reco[key]);
          }
        }
        if(reco.destroy){
          formData.append('material_item[media_attributes]['+i+'][_destroy]', true);
        }
        i+=1;
      }
      if(_.isUndefined(material.id)){
        var that = this
        axios.post('/material_items.json', formData).then(response => {
          that.material.id = response.data.id;
          that.$emit('addMaterial', that.material);
          that.unEditPest(material);
        });
      }else{
        axios.put('/material_items/'+material.id+'.json', formData).then(response => {
          this.unEditPest(material);
        });
      }
    },
    
},
computed: {
      hasRemoveListener(){
          return this.$listeners && this.$listeners.removeMaterial
      }
    }
}
</script>

<style scoped>
.login_button{
  color: red;
}
p {
  font-size: 2em;
  text-align: center;
}
nav {
  background-color: #626262;
  height: 100px;
}
nav a{
  margin: 15px;
}
select{
  display: block;
}
.settingsform .btn-large {
  border-radius: 8px;
  background-color: white;
  color: black;
  border-color: #00CC66;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.solidgreen {
   background-color: #00CC66 !important;
}
.btn-small {
    color: black;
    border-radius: 8px;
}
.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}
.row .col {
  margin-top: 0px;
}
.right-align{
  line-height: 2;
}
select{
  display: block;
  background-color: white !important;
  border-radius: 4px !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgb(140, 140, 140) !important;
  padding-left: 5px !important;
  height: 35px !important;
}
</style>